import React, { FunctionComponent } from "react"
import { Line } from "react-chartjs-2"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { exponentialSample } from "@components/Distribution/ExponentialDistributionChart/exponential.calc"

interface Props {
  loc: number
  scale: number
  lbound?: number
  ubound?: number
}

export const ExponentialDistributionChart: FunctionComponent<Props> = ({
  loc = 1,
  scale = 0,
  lbound = undefined,
  ubound = undefined,
}) => {
  const data = exponentialSample(loc, scale, lbound, ubound)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    datasets: [
      {
        data,
        fill: false,
        tension: 0.1,
      },
    ],
  }
  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        min: Math.max(loc, lbound ?? 0),
        type: "linear",
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        type: "linear",
        title: {
          display: true,
          text: "Probability Density",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
